import React from "react";

export default (props) => (
    <ul className={'code my-3 keyword-list orange-bullets'}>
        {props.keywords.map((value, index) => {
            return (
                <li key={index} className="mr-3">
                    {value}
                </li>)
        })}
    </ul>
)